// @flow
import * as React from 'react';

import {
  HOW_IT_WORKS,
  FINDER_FACILITY,
  FINDER_TREATMENT,
  FINDER_DOCTOR,
  CONTACT_US,
  FINDER_PACKAGE,
  // FINDER_PACKAGE
} from '@routes';

import { withTranslation } from '@i18n';

import NavigationDropdown from '../NavigationDropdown';
import NavigationLink from '../NavigationLink';

import { StyledLinksNavigation } from './styles';

const NavigationLinks = ({ t, heroSection }): React.Node => (
  <StyledLinksNavigation>
    <NavigationLink label={t('HowItWorks')} route={HOW_IT_WORKS} heroSection={heroSection} />

    <NavigationDropdown
      label={t('Explore')}
      links={[
        {
          id: 'nav-explore-facility-link',
          linkLabel: t('FacilityFinder'),
          route: FINDER_FACILITY
        },
        { id: 'nav-explore-doctor-link', linkLabel: t('DoctorFinder'), route: FINDER_DOCTOR },
        { id: 'nav-explore-treatment-link', linkLabel: t('TreatmentFinder'), route: FINDER_TREATMENT },
      ]}
      heroSection={heroSection}
    />
    {/* <NavigationLink label={t('OnlineConsultation')} route={ONLINE_CONSULTATION} /> */}
    <NavigationLink label={t('Packages')} route={FINDER_PACKAGE} heroSection={heroSection} />
    <NavigationLink label={t('Contact')} route={CONTACT_US} heroSection={heroSection} />

    {/* <NavigationDropdown
      label={t('Stories')}
      links={[
        { id: 'nav-community-magazine-link', linkLabel: t('Testemonials'), route: BLOG },
        { id: 'nav-community-friends-link', linkLabel: t('Pricing'), route: MEDIMAKR_FRIENDS }
      ]}
    /> */}
  </StyledLinksNavigation>
);

export default withTranslation('Navigation')(NavigationLinks);
